import { z } from 'zod';
import { environment } from './util.environment.js';
import { makeEnvironmentRef } from './util.make-environment-ref.js';

const truthySchema = z.enum(["true", "1", "on", "yes"]);
function asBoolean(key, options) {
  return makeEnvironmentRef(() => {
    var _a;
    const input = (_a = environment.read(key, options)) == null ? void 0 : _a.toLowerCase();
    const isTruthy = truthySchema.safeParse(input);
    return isTruthy.success;
  });
}

export { asBoolean };
//# sourceMappingURL=parser.boolean.js.map
